import React from 'react';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import useServicesPerYearTotalChart from './hooks/useServicesPerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const ServicesPerYearTotal = ({ heigth = 400 }) => {
    const { module } = useServicesChartsDataContext();
    const { series, subtitles } = useServicesPerYearTotalChart();

    return (
        <SimpleBars
            title={`Evolução ${module.sectionTitle} por Ano`}
            series={series}
            subtitles={subtitles}
            values={[]}
        />
    );
};
